export default "__VITE_ASSET__COjuE605__"